module.exports = __webpack_public_path__ + "img/sub-title-icon.dfe74bf2.png";